module.exports = __webpack_public_path__ + "img/logo.d6cae6e3.png";